import { Caption } from '@depop/web-thrift-ui/Typography';
import clsx from 'clsx';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { type IconComponent } from '@/modules/home/types';

type TrustSignalProps = {
  icon: IconComponent;
  title: string;
  description: string;
  href?: string;
  onClick?: () => void;
};

export function TrustSignal({
  icon: Icon,
  title,
  description,
  href,
  onClick,
}: TrustSignalProps) {
  const content = (
    <>
      <Icon size="md" aria-hidden="true" />
      <Caption className={styles.trustDescription} variant="lg-bold">
        {title}
      </Caption>
      <Caption
        className={clsx(styles.trustDescription, styles.trustSignalDescription)}
        variant="lg-regular"
      >
        {description}
      </Caption>
    </>
  );

  if (href) {
    return (
      <ExtendedLink
        className={clsx(styles.trustSignal, styles.trustSignalLink)}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
      >
        {content}
      </ExtendedLink>
    );
  }

  return <div className={styles.trustSignal}>{content}</div>;
}
